// src/components/Layout.js
import React, { useEffect, useState } from 'react';
import Sidebar from './Sidebar';
import Header from './Header';
import { Outlet, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Toastmessage from './Toast';
import { logout,userRoles } from '../features/auth/AuthSlice';
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom';
import { authApi } from '../api/api';

const Layout = () => {
  // Get the isExpand value from Redux state
  const isExpanded = useSelector((state) => state.auth.isExpand);

  const location = useLocation(); // Use useLocation to get the current URL

  console.log(location)

  const [userRoleAccess , setUserRoleAccess] = useState([])

  const token = useSelector((state) => state.auth.token); // Get the token from Redux
  const userID = useSelector((state) => state.auth.id); // Get the userID from Redux

  const dispatch = useDispatch()
  const navigate = useNavigate();

  useEffect(() => {
    fetchRole();
  }, [token, userID,]); // Run effect when token or userID changes


  // Define fetchLocations separately to reuse it
  const fetchRole = async () => {
    const input_token = userID+'LEFT'; // Replace with your actual token
    const apiUrl = 'list_of_modules_left_menu'; // Replace with the actual API endpoint

    const dataInput = {
      login_user_id: userID
    };

    try {
      const data = await authApi(input_token, dataInput, apiUrl, token);

      if (data && data.success) {

        dispatch(userRoles(data.data));
        
      } else if (data && data.message === 'Token has expired') {
        dispatch(logout());
        localStorage.removeItem('token');
        await Toastmessage('Session expired. Redirecting to login...', false);
        navigate('/login');
      } else if (data === undefined) {
        await Toastmessage('No response from server', false);
      } else {
        await Toastmessage(data?.message || 'An error occurred', false);
      }

    } catch (error) {
      console.error("Error fetching data:", error);
      if (error.response && error.response.status === 401) {
        dispatch(logout());
        localStorage.removeItem('token');
        await Toastmessage('Session expired. Redirecting to login...', false);
        navigate('/login');
      } else {
        await Toastmessage('Something went wrong', false);
      }
    }
  };


  return (
    <div>
      <Header /> {/* Fixed header at the top */}
      <div style={{ display: 'flex' }}>
        <Sidebar  moduleAccess={userRoleAccess}/>
        <main
          className={isExpanded ? 'collapsed overFlowcss' : 'expanded overFlowcss'} // Conditional className
          style={{
            marginTop: '60px',
            marginLeft: window.innerWidth <= 768 ? '0px' : isExpanded ? '94px' : '261px', // Dynamic marginLeft for mobile
            marginRight: '0px',
            width: '100%',
            overflowX: location?.pathname === "/management-reports" ? 'unset' : 'hidden',
          }}
        >
          <Outlet /> {/* Renders nested routes */}
        </main>
      </div>
    </div>
  );
};

export default Layout;
